/* eslint-disable no-plusplus */
/* eslint-disable no-console */
/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
(function handleSearchBlock() {
  function processSearchBlock() {
    const searchBlock = document.querySelector('.header-main .region-header .search-block-form');
    const searchWrapper = document.querySelector(
      '.header-main .region-header .search-block-form #search-block-wrapper',
    );
    const search = document.querySelector(
      '.header-main .region-header .search-block-form #search-block-wrapper input.form-search',
    );
    const closeIcon = document.querySelector(
      '.header-main .region-header .search-block-form #search-block-wrapper #close-icon',
    );

    const menu = document.querySelector('.menu-main');
    const menuItems = Array.from(document.querySelectorAll('.menu-main .menu-main__item:not(:last-child)'));

    let searchBlockOffsetLeft = searchBlock.offsetLeft;

    const breakpoint = window.matchMedia('(min-width: 1600px)');
    let hideMenu = true;

    function breakpointChecker() {
      if (breakpoint.matches === true) {
        hideMenu = false;
      } else {
        hideMenu = true;
      }
    }

    window.addEventListener('resize', () => {
      searchBlockOffsetLeft = searchBlock.offsetLeft;
    });

    breakpointChecker();
    breakpoint.addEventListener('change', breakpointChecker);

    function handleHideMenu() {
      menuItems.forEach((item) => {
        item.style.visibility = 'hidden';
        item.opacity = 0;
      });

      searchBlock.style.position = 'absolute';
      searchBlock.style.left = `${searchBlockOffsetLeft}px`;
      searchBlock.style.top = '50%';
      searchBlock.style.transform = 'translateY(-50%)';

      search.style.width = `${menu.getBoundingClientRect().width - 180}px`;
    }

    function handleShowMenu() {
      menuItems.forEach((item) => {
        item.style.visibility = '';
        item.opacity = '';
      });
      searchBlock.style.position = '';
      searchBlock.style.left = '';
      searchBlock.style.top = '';
      searchBlock.style.transform = '';
    }

    // Input focus
    search.onfocus = function () {
      if (hideMenu) {
        handleHideMenu();
      }
      searchWrapper.classList.add('search-expanded');
      this.addEventListener('transitionend', function () {
        closeIcon.style.display = 'block';
      });
    };

    // Input blur
    search.onblur = function () {
      searchWrapper.classList.remove('search-expanded');
      closeIcon.classList.add('closing');

      this.addEventListener('transitionend', function () {
        closeIcon.classList.remove('closing');
        closeIcon.style.display = 'none';
      });

      search.style.width = '';

      setTimeout(() => {
        handleShowMenu();
      }, 1000);
    };

    // Close
    closeIcon.onclick = function () {
      this.classList.add('closing');

      document.activeElement.blur();
      search.value = '';

      setTimeout(function () {
        closeIcon.classList.remove('closing');
      }, 1000);
    };
  }

  const maxRetries = 5;
  const retryDelay = 1000; // 1 second
  let retryCount = 0;

  function checkSearchBlock() {
    const searchBlock = document.querySelector('.header-main .region-header .search-block-form');

    if (searchBlock) {
      console.log('Search block found!');
      processSearchBlock();
    } else if (retryCount < maxRetries) {
      retryCount++;
      console.log(`Search block not found, retrying (${retryCount}/${maxRetries})...`);
      setTimeout(checkSearchBlock, retryDelay);
    } else {
      console.log('Search block not found after maximum retries');
    }
  }

  checkSearchBlock();
})();
